import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteCardComponent } from './quote-card/quote-card.component';
import { ShipmentViewComponent } from './shipment-view/shipment-view.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShipmentEditorComponent } from './shipment-editor/shipment-editor.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ShipmentsPageComponent } from './shipments-page/shipments-page.component';
import { ShipmentTableComponent } from './shipments-table/shipment-table.component';
import { ShipmentPageComponent } from './shipment-page/shipment-page.component';
import { ShipmentPackagesComponent } from './shipment-packages/shipment-packages.component';
import { ShipmentInternationalComponent } from './shipment-international/shipment-international.component';
import { ShipmentOptionsComponent } from './shipment-options/shipment-options.component';
import { CourierOptionEditorComponent } from './courier-option-editor/courier-option-editor.component';
import { CourierOptionMenuComponent } from './courier-option-menu/courier-option-menu.component';
import { ShipmentReferenceEditorComponent } from './shipment-reference-editor/shipment-reference-editor.component';
import { ShipmentUndoRedoComponent } from './shipment-undo-redo/shipment-undo-redo.component';
import { ShipmentModeComponent } from './shipment-mode/shipment-mode.component';
import { CourierFormEditorComponent } from './courier-form-editor/courier-form-editor.component';
import { ShipmentPreparationComponent } from './shipment-preparation/shipment-preparation.component';
import { ShipmentQuotingComponent } from './shipment-quoting/shipment-quoting.component';
import { MaterialModule } from '../material/material.module';
import { QuoteProgressComponent } from './quote-progress/quote-progress.component';
import { SaveIndicatorComponent } from './save-indicator/save-indicator.component';
import { CreateShipmentButtonComponent } from './create-shipment-button/create-shipment-button.component';
import {
  ShipmentPreparationSummaryComponent
} from './shipment-preparation-summary/shipment-preparation-summary.component';
import { ShipmentIndicatorComponent } from './shipment-indicator/shipment-indicator.component';
import { ShipmentsTableFilterComponent } from './shipments-table-filter/shipments-table-filter.component';
import { ShipmentCardComponent } from './shipment-card/shipment-card.component';
import { ShipmentSubmitComponent } from './shipment-submit/shipment-submit.component';
import { CourierLogoComponent } from './courier-logo/courier-logo.component';
import { ViolationsModalComponent } from './violations-modal/violations-modal.component';
import { ShipmentTableActionsComponent } from './shipment-table-actions/shipment-table-actions.component';
import { BatchPageComponent } from './batch-page/batch-page.component';
import { BatchTableComponent } from './batch-table/batch-table.component';
import { BatchTableFilterComponent } from './batch-table-filter/batch-table-filter.component';
import { ShipmentTrackingComponent } from './shipment-tracking/shipment-tracking.component';
import { TrackingGroupComponent } from './tracking-group/tracking-group.component';
import { TrackingGroupEventComponent } from './tracking-group-event/tracking-group-event.component';
import { CityscapeScrollAnimationComponent } from './cityscape-scroll-animation/cityscape-scroll-animation.component';
import { ProgressBackgroundComponent } from './progress-background/progress-background.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { ShipmentDocumentUploadModalComponent } from './shipment-document-upload-modal/shipment-document-upload-modal.component';
import { ShipmentDocumentsComponent } from './shipment-documents/shipment-documents.component';

const appearanceDefaults: MatFormFieldDefaultOptions = {
    appearance: 'fill',
    subscriptSizing: 'dynamic'
    // Note: density isn't included here yet — see below for a workaround.
};

@NgModule({
    exports: [
        ShipmentViewComponent,
        ShipmentsPageComponent,
        ShipmentPageComponent,
        ShipmentUndoRedoComponent,
        ShipmentModeComponent,
        SaveIndicatorComponent,
        CreateShipmentButtonComponent,
        ShipmentCardComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        ShipmentViewComponent,
        QuoteCardComponent,
        ShipmentEditorComponent,
        ShipmentTableComponent,
        ShipmentsPageComponent,
        ShipmentPageComponent,
        ShipmentPackagesComponent,
        ShipmentInternationalComponent,
        ShipmentOptionsComponent,
        ShipmentTableActionsComponent,
        CourierOptionEditorComponent,
        CourierOptionMenuComponent,
        ShipmentReferenceEditorComponent,
        ShipmentUndoRedoComponent,
        ShipmentModeComponent,
        CourierFormEditorComponent,
        ShipmentPreparationComponent,
        ShipmentQuotingComponent,
        QuoteProgressComponent,
        SaveIndicatorComponent,
        CreateShipmentButtonComponent,
        ShipmentPreparationSummaryComponent,
        ShipmentIndicatorComponent,
        ShipmentsTableFilterComponent,
        ShipmentCardComponent,
        ShipmentSubmitComponent,
        CourierLogoComponent,
        ViolationsModalComponent,
        BatchPageComponent,
        BatchTableComponent,
        BatchTableFilterComponent,
        ShipmentTrackingComponent,
        TrackingGroupComponent,
        TrackingGroupEventComponent,
        CityscapeScrollAnimationComponent,
        ProgressBackgroundComponent,
        ShipmentDocumentUploadModalComponent,
        ShipmentDocumentsComponent
    ],
    providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearanceDefaults }
    ]
})
export class ShipmentModule {
}
